// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index." + {"12":"a622fd3f64115035c3b4","777":"e8998e523f5de356296f"}[chunkId] + ".js";
};